<template>
  <div>
    <div class="icon-container">
      <div :id="'show-tooltip-' + tooltipKey" class="icon-center-container">
        <v-icon name="regular/question-circle" class="icon-default icon" scale="1.5"></v-icon>
        <v-icon name="question-circle" class="icon-hover icon" scale="1.5"></v-icon>
      </div>
    </div>
    <b-tooltip
      class="tooltip"
      :target="'show-tooltip-' + tooltipKey "
      placement="bottom"
      triggers="hover">
      <div v-html="rawHTML"></div>
    </b-tooltip>
  </div>
    
</template>

<script>
import tooltips from '@/utils/tooltipsUtil.js'

import Icon from 'vue-awesome/components/Icon'
import 'vue-awesome/icons/question-circle'
import 'vue-awesome/icons/regular/question-circle'

export default {
  name: "Tooltip",
  components: {
    'v-icon': Icon
  },
  props: {
    tooltipKey: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      tooltips,
      rawHTML: null
    }
  },
  mounted() {
    this.rawHTML = this.tooltips[this.tooltipKey]
  }
}

</script>

<style lang="scss" scoped>
  .icon-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-items: center;
    width: 100%;
    height: 100%;

    .icon-center-container {
      position: relative;
      width: 26px;
      height: 26px;
      .icon {
          position: absolute;
          top: 0;
          left: 0;

          display: block;
      }
      .icon-default {
          transition: opacity .3s;
      }

      .icon-hover {
          transition: opacity .3s;
          opacity: 0;
      }

      &:hover {
        .icon-hover {
          opacity: 1;
        }
        .icon-default {
          opacity: 0;
        }
      }
    }    
  }
</style>